var _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopRanking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.45068,
    y: 1.54297,
    width: 21.0986,
    height: 21.9155,
    rx: 10.5493,
    fill: "url(#paint0_linear_1553_5709)",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.569 18.4585V16.988H19.2732V8.57114L17.1605 9.88945L16.4507 8.58804L19.7803 6.54297H21.0141V16.988H23.5493V18.4585H16.569Z",
    fill: "#F0AC2B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.45068,
    y: 1.54297,
    width: 21.0986,
    height: 21.9155,
    rx: 10.5493,
    stroke: "#ECB855",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1553_5709",
    x1: 11.704,
    y1: 4.92186,
    x2: 25.0349,
    y2: 18.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD12F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD12F",
    stopOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRanking);
export default __webpack_public_path__ + "static/media/top-ranking.f4e6ab50f02bba3d46f656efd5fbeff9.svg";
export { ForwardRef as ReactComponent };